<mat-dialog-content>
    <h1>Részletek</h1>
    <table>
        <tr>
            <th>Mező</th>
            <th>Érték</th>
        </tr>
        <tr>
            <td>ID</td>
            <td>{{data.id}}</td>
        </tr>
        <tr>
            <td>Létrehozás dátuma</td>
            <td>{{data.creationDateTime | date: 'yyyy.MM.dd. HH:mm:ss' }}</td>
        </tr>
        <tr>
            <td>Típus</td>
            <td>{{data.type == 'PAYMENT_REQUEST_UNATTENDED' ? 'Fizető fél részvétele nélkül': 'Fizető fél részvételével'}}</td>
        </tr>
        <tr>
            <td>Fizetési határidő</td>
            <td>{{data.validityDate ? (data.validityDate | date: 'yyyy.MM.dd. HH:mm:ss') : '-'}}</td>
        </tr>
        <tr>
            <td>Lejárati idő</td>
            <td>{{data.deadline ? (data.deadline | date: 'yyyy.MM.dd. HH:mm:ss') : '-'}}</td>
        </tr>
        <tr>
            <td>Kedvezményezett számlaszáma</td>
            <td>{{data.payee?.accountNumber || '-'}}
            </td>
        </tr>
        <tr>
            <td>Kedvezményezett neve</td>
            <td>{{data.payee?.name || '-'}}
            </td>
        </tr>
        <tr>
            <td>Fizető fél számlaszáma</td>
            <td>{{data.payer?.accountNumber || '-'}}</td>
        </tr>
        <tr>
            <td>Fizető fél neve</td>
            <td>{{data.payer?.name || '-'}}</td>
        </tr>
        <tr>
            <td>Fizető fél e-mail címe</td>
            <td>{{data.payer?.emailAddress || '-'}}</td>
        </tr>
        <tr>
            <td>Összeg</td>
            <td>{{data.amount || '-'}}</td>
        </tr>
        <tr>
            <td>Összeg módosítható</td>
            <td>{{data.amountModifiable ? 'Igen' : 'Nem'}}</td>
        </tr>
        <tr>
            <td>Közlemény</td>
            <td>{{data.comment || '-'}}</td>
        </tr>
        <tr>
            <td>Közlemény módosítható</td>
            <td>{{data.commentModifiable ? 'Igen' : 'Nem'}}</td>
        </tr>
        <tr>
            <td>Státusz</td>
            <td>{{data.status}}</td>
        </tr>
    </table>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>BEZÁRÁS</button>
</mat-dialog-actions>